module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fronttitle"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _vm._v(" Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘Integrity’"), _c('br'), _vm._v("\nSpeech, Budapest, October 1985. Translated by Amos Oz\nand Maggie Goldberg-Bartura.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘Has Israel Altered its Visions?’"), _c('br'), _vm._v(" "), _c('em', [_vm._v("New York Times Magazine,")]), _vm._v(" 11 July 1982. Translated by\nMaggie Goldberg-Bartura and Amos Oz.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘The Real Cause of my Grandmother’s Death’"), _c('br'), _vm._v("\nLecture, Tel Aviv, 1992; Cambridge 1993. Translated by\nOra Cummings.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘From Jerusalem to Cairo: Escaping from the Shadow of the Past’"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Encounter,")]), _vm._v(" 1982. Translated by Nicholas de Lange.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘Between Europe and the Negev Desert’"), _c('br'), _vm._v("\nInterview, "), _c('em', [_vm._v("Frankfurter Allgemeine Zeitung,")]), _vm._v(" 3 May 1990.\nTranslated by Jenny Chapman.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘Peace and Love and Compromise’"), _c('br'), _vm._v("\nAcceptance Speech, International Peace Prize of the German\nPublishers’ Association, Frankfurt, October 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘Whose Holy Land? Divided Israel in Palestine’"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Weekend Guardian,")]), _vm._v(" 23–24 December 1989. Translated by\nNicholas de Lange.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _vm._v(" ‘Telling Stories under Siege’"), _c('br'), _vm._v("\nSpeech, Writers’ Conference, Barcelona 1976. Translated by\nMaggie Goldberg-Bartura.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘The Israeli-Palestinian Conflict: Tragedy, Comedy and Cognitive Block’"), _c('br'), _vm._v("\nLecture, Ann Arbor, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘At the Bridge’"), _c('br'), _vm._v("\nGuardian, 1 September 1993. Translated by Ora Cummings.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘Hizbollah in a Skullcap’"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Observer,")]), _vm._v(" 27 February 1994. Translated by Ora Cummings.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("‘Clearing the Minefields of the Heart’"), _c('br'), _vm._v("\nSpeech, Peace Now rally, Tel Aviv, 4 September 1993. Translated\nby Ora Cummings.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1160f805","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0